import { render } from "./CreateOrganizationDialog.vue?vue&type=template&id=073b16a9"
import script from "./CreateOrganizationDialog.vue?vue&type=script&lang=js"
export * from "./CreateOrganizationDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__